import React from 'react';
import { Link } from 'react-router-dom';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LzSApp from '@lz/app/App';
import { lzFKebabToWordCase } from '@lz/services/String';
import { lzFGetNavSubLinks } from '@lz/services/Utils';
import { LzTBreadcrumbItems, LzTNavItem, LzTNavItems } from '../../layout/Navigation/types';

export interface LzPPageNavParent {
    navItems: LzTNavItems;
    private?: boolean;
    breadcrumbs?: LzTBreadcrumbItems;
}

const LzXPageNavParent = (props: LzPPageNavParent) => {
    const slug = window.location.hash
        .split('/')
        .filter((x) => x)
        .slice(1)[0];
    const list = lzFGetNavSubLinks(props.navItems, slug);

    return (
        <LzSApp.WrapperTemplate private={!!props.private} screenTitle={lzFKebabToWordCase(slug)} breadcrumbs={props.breadcrumbs}>
            <Container maxWidth="sm">
                <Paper elevation={2}>
                    <List component="nav" className="lz-text-colored-link-wrapper">
                        <ListSubheader>Please select a link...</ListSubheader>
                        {list.map((item: LzTNavItem, dex: number) => (
                            <Link key={'link-' + dex} to={item.route || ''}>
                                <ListItemButton>
                                    <ListItemIcon>{item.icon}</ListItemIcon>
                                    <ListItemText primary={item.title} />
                                </ListItemButton>
                            </Link>
                        ))}
                    </List>
                </Paper>
            </Container>
        </LzSApp.WrapperTemplate>
    );
};

export default LzXPageNavParent;
